import Api from '@/services/api'

export default {
    funcionalidades () {
        return [
            {
                nome: 'Pesquisa',
                icone: 'search',
                texto: 'Tenha à sua disposição mais de 27 mil códigos NCM/NBM, considerando a correlação entre todas as versões do SH (1995-2022), a descrição da TIPI e a expressa na legislação. '
            },
            {
                nome: 'Cenários',
                icone: 'columns',
                texto: 'Consulte operação no mercado interno (interna/interestadual) e mercado externo (importação/exportação) realizada por estabelecimento industrial, atacadista ou varejista.'
            },
            {
                nome: 'Compare',
                icone: 'chart-bar',
                texto: 'Após preencher os dados, receba em sua tela até 3 cenários diferentes simultaneamente e analise o melhor caso para sua empresa.'
            },
            {
                nome: 'Cadastro',
                icone: 'address-card',
                texto: 'Cadastre produtos para facilitar a consulta no cenário, além de auditar a vigência/alteração do código NCM/NBM e sua correlação com o CNAE.'
            },
            {
                nome: 'Empresas',
                icone: 'building',
                texto: 'Cadastre empresas para facilitar a consulta no cenário, além de auditar a correlação da NCM da operação com o CNAE da empresa.'
            },
            {
                nome: 'Tributos',
                icone: 'calculator',
                texto: 'ICMS, FCP, IPI, PIS/COFINS, Imposto de Importação, Imposto de Exportação, CIDE-Combustíveis e Defesa Comercial.'
            }
        ]
    },
    updateNaoExibirLp () {
        new Api().get('Usuario/updateExibirLP').then(response => {
            // console.log('updateNaoExibirLp', response)
        })
    }
}